import { add, remove, qs } from "@fluorescent/dom";
import Delegate from "ftdomdelegate";

import { on, emit } from "@/glow/events";
import { makeRequest } from "@/lib/xhr";
import FreeShippingBar from "@/lib/free-shipping-bar";
import { animatePurchaseConfirmation, shouldAnimate } from "@/lib/animation";

const selectors = {
  container: "[js-purchase-confirmation-container]",
  closeButton: "[data-confirmation-close]",
  freeShippingBar: ".free-shipping-bar",
  header: "[js-header]",
  quickCart: ".quick-cart",
  viewCartButton: ".purchase-confirmation-popup__view-cart",
};

const classes = {
  active: "active",
  fixed: "fixed",
  hidden: "hidden",
};

export default function PurchaseConfirmationPopup(node) {
  if (!node) return;
  const quickCartEnabled = Boolean(qs(selectors.quickCart, document));
  const container = qs(selectors.container, node);
  const header = qs(selectors.header, document);
  const headerIsSticky = header.dataset.enableStickyHeader == "true";
  let purchaseConfirmationAnimation = null;

  if (shouldAnimate(node)) {
    purchaseConfirmationAnimation = animatePurchaseConfirmation(node);
  }

  const delegate = new Delegate(node);

  delegate.on("click", selectors.viewCartButton, event => {
    if (!quickCartEnabled) return;
    event.preventDefault();
    emit("quick-cart:open");
    close();
  });

  delegate.on("click", selectors.closeButton, event => {
    event.preventDefault();
    close();
  });

  on("confirmation-popup:open", (_, { product }) => getItem(product));

  function getItem(product) {
    const requestUrl = `${window.theme.routes.cart.base}/?section_id=purchase-confirmation-popup-item`;

    makeRequest("GET", requestUrl).then(response => {
      let contentContainer = document.createElement("div");
      contentContainer.innerHTML = response;
      container.innerHTML = contentContainer.innerHTML;

      const freeShippingBar = qs(selectors.freeShippingBar, container);

      if (freeShippingBar) {
        FreeShippingBar(freeShippingBar);
      }

      // Show product within cart that was newly added
      const addedProduct = qs(`[data-product-key="${product.key}"]`, node);
      remove(addedProduct, classes.hidden);

      open();
    });
  }

  function _getFullHeaderHeight() {
    const rootStyle = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(
      rootStyle.getPropertyValue("--height-header")
    );
    const announcementHeight = parseFloat(
      rootStyle.getPropertyValue("--announcement-height")
    );

    return headerHeight + announcementHeight;
  }

  function open() {
    if (!headerIsSticky) {
      if (window.scrollY > _getFullHeaderHeight()) {
        container.classList.add(classes.fixed);
      } else {
        container.classList.remove(classes.fixed);
      }
    }

    add(node, classes.active);

    if (shouldAnimate(node)) {
      purchaseConfirmationAnimation.animate();
    }

    const timeout = setTimeout(() => {
      close();
    }, 5000);

    // Clear timeout if mouse enters, then close if it leaves
    container.addEventListener(
      "mouseover",
      () => {
        clearTimeout(timeout);
        container.addEventListener("mouseleave", close, { once: true });
      },
      { once: true }
    );
  }

  function close() {
    remove(node, classes.active);

    if (shouldAnimate(node)) {
      setTimeout(() => {
        purchaseConfirmationAnimation.reset();
      }, 500);
    }
  }
}
